import { theme } from "@pallet-hq/hegel"
import { keyframes } from "@emotion/react"
import styled from "@emotion/styled"
import React, { useLayoutEffect, useRef } from "react"
import { FiStar } from "react-icons/fi"

const AnimatedStar = ({ filled }: { filled: boolean }) => {
    const shouldAnimate = useRef(false)
    useLayoutEffect(() => {
        if (!shouldAnimate.current) {
            shouldAnimate.current = true
        }
    })

    if (shouldAnimate.current) {
        return filled ? <AnimatedFilledStar /> : <AnimatedUnfilledStar />
    }
    return filled ? <FilledStar /> : <UnfilledStar />
}

export default React.memo(AnimatedStar)

const StyledStar = styled(FiStar)`
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
    size: ${theme.space.small};
    transform-origin: center;
    animation-duration: 300ms;
    animation-timing-function: ease-in;
`

const saveTransition = keyframes`
  from {
    fill: #ffffff;
    stroke: #898990;
    opacity: 1;
    transform: rotate(0deg) scale(1);
  }
  50% {
    fill: #ffffff;
    stroke: #898990;
    transform: rotate(10deg) scale(0.6);
    opacity: 0;
  }
  to {
    fill: ${theme.colors.gold400};
    stroke: ${theme.colors.gold400};
    opacity: 1;
    transform: rotate(0deg) scale(1);
  }
`

const unsaveTransition = keyframes`
  from {
    fill: ${theme.colors.gold400};
    stroke: ${theme.colors.gold400};
    opacity: 1;
    transform: rotate(0deg) scale(1);
  }
  50% {
    fill: #ffffff;
    stroke: #898990;
    transform: rotate(10deg) scale(0.6);
    opacity: 0;
  }
  to {
    fill: #ffffff;
    stroke: #898990;
    opacity: 1;
    transform: rotate(0deg) scale(1);
  }
`

const FilledStar = styled(StyledStar)`
    stroke: ${theme.colors.gold400};
    fill: ${theme.colors.gold400};
`

const AnimatedFilledStar = styled(FilledStar)`
    animation-name: ${saveTransition};
`

const UnfilledStar = styled(StyledStar)`
    stroke: ${theme.colors.gray600};
    fill: ${theme.colors.white};
`

const AnimatedUnfilledStar = styled(UnfilledStar)`
    animation-name: ${unsaveTransition};
`
